import React from "react";
import "./styles.scss";
import logo from "../../../../shared/resources/in-white-logo-only.png";

interface IProps {
  title: string;
}

const PageHeader = (props: IProps) => {
  return (
    <div>
      <div
        className="page-header-wrapper "
        style={{
          width: `calc(100vw - 300px)`,
        }}
      >
        <div className="blue-line ">
          <div className="text-left title">
            <span className=" header-text">{props.title}</span>
          </div>
          <div className="image-logo">
            <img src={logo} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
